import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@/app/App'
import { AppProviders } from '@/app/providers'
import '@/index.css'
import { initErrorReporting } from '@/core/reporting'
import { initializeDiagnosticReportingTags } from '@/app/diagnostics/diagnostics'

await initErrorReporting()

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('App startup failed: #root element is missing')
}

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </StrictMode>,
)

void initializeDiagnosticReportingTags().catch((error: unknown) => {
  console.error('Could not initialize diagnostic reporting tags.', error)
})
